interface BrandProps {
  className?: string;
  mark?: boolean;
}

export default function Brand({ className = '', mark = true }: BrandProps) {
  return <span className={`wordmark ${className}`.trim()}>
    {mark && <svg className="brand-mark" viewBox="0 0 28 28" aria-hidden>
      <path className="brand-letter" d="M5.2 7.4h17.6M14 7.9v13.6" fill="none" />
      <path className="brand-route" d="M5.4 19.6c3.7-.3 5.3-2.5 7.8-3.8 2.8-1.5 5.4-.5 9.4-4.1" fill="none" />
      <circle className="brand-origin" cx="5.4" cy="19.6" r="1.45" />
      <circle className="brand-destination" cx="22.6" cy="11.7" r="1.45" />
    </svg>}
    <span>Tragenda</span>
  </span>;
}
